module.exports = __webpack_public_path__ + "img/packages/h8.3c620c.png";